import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import MethodologyAnchor from '../MethodologyAnchor';
import { StyledRecharts } from './Recharts.styled';

const MostWantedTechnologies: React.FC = () => {
  const data = [
    { language: 'AWS', value: 28.00875273522976, fill: '#08306B' },
    { language: 'React', value: 18.38074398249453, fill: '#08306B' },
    { language: 'CSS', value: 15.098468271334792, fill: '#08519C' },
    { language: 'NodeJS', value: 15.098468271334792, fill: '#08519C' },
    { language: 'HTML', value: 14.00437636761488, fill: '#2171B5' },
    { language: 'Docker', value: 13.566739606126916, fill: '#2171B5' },
    { language: 'MySQL', value: 9.409190371991247, fill: '#4292C6' },
    { language: 'MongoDB', value: 8.752735229759299, fill: '#4292C6' },
    { language: 'PostgreSQL', value: 8.533916849015318, fill: '#6BAED6' },
    { language: 'Kubernetes', value: 8.533916849015318, fill: '#6BAED6' }
  ];

  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer height={400}>
          <BarChart data={data} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 20 }}
              domain={[0, 40]}
              tickFormatter={(tick) => {
                return `${tick}%`;
              }}
            />
            <YAxis
              type="category"
              dataKey="language"
              tickLine={false}
              width={120}
            />
            <Tooltip
              cursor={{ fill: 'transparent' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value.toFixed(1) + '%', '']}
              wrapperClassName="tooltip-y"
            />
            <Bar dataKey="value" fill="fill" barSize={12} radius={5} />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
      <MethodologyAnchor />
    </div>
  );
};

export default MostWantedTechnologies;
